import React from 'react';
import done from './img/iconDone.svg';
import save from './img/iconSave.svg';
import history from './img/iconHistory.svg';
import repeat from './img/iconRepeat.svg';
import edit from './img/iconEdit.svg';
import cancel from './img/iconCancel.svg';
import { formatDateWithTime } from 'utils/date';

interface StepInfo {
  step: number | null;
  subtitle: string;
  actions:
    | Array<{
        text: string;
        action: string;
        icon: string;
      }>
    | null
    | false;
  info: React.ReactNode | false;
  showPrimaryButton?: boolean;
  isError: boolean;
  isGray: boolean;
  listItems: Array<{
    id: string;
    name: string;
    icon: string;
    color?: string;
  }>;
}

export const STEPS_MAP: Record<string, StepInfo> = {
  moderation_in_progress: {
    step: 2,
    subtitle: 'Проходит проверка заказа со стороны площадки. Это не займет много времени',
    actions: null,
    info: false,
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'cancel', name: 'Отменить заказ', icon: cancel, color: '#E10D0D' },
    ],
  },
  moderation_failed: {
    step: 2,
    subtitle: 'Сегодня в 12:00',
    actions: null,
    info: false,
    isError: true,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'cancel', name: 'Отменить заказ', icon: cancel, color: '#E10D0D' },
    ],
  },
  worker_invited_by_customer: {
    step: 3,
    subtitle: 'Ожидаем принятия заказа от исполнителя в приложении',
    actions: null,
    info: false,
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
      { id: 'cancel', name: 'Отменить заказ', icon: cancel, color: '#E10D0D' },
    ],
  },
  //------------------Фиксированная оплата------------------
  worker_approved_order: {
    step: 4,
    subtitle: 'Заказ в работе. Ожидаем завершения заказа исполнителем.',
    actions: null,
    info: false,
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
      { id: 'cancel', name: 'Отменить заказ', icon: cancel, color: '#E10D0D' },
    ],
  },
  //------------------Сдельная оплата------------------
  worker_approved_order_unit_based: {
    step: 4,
    subtitle: 'Чтобы перейти в к завершению заказа, подтверди объем оказанных услуг',
    actions: [
      {
        text: 'Подтвердить объем',
        action: 'confirm_volume',
        icon: done,
      },
    ],
    info: React.createElement(
      'p',
      { style: { color: '#000' } },
      'Нажимая «Подтвердить» ты фиксируешь объем оказанных услуг и исполнитель может перейти к завершению заказа',
    ),
    showPrimaryButton: true,
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
      { id: 'cancel', name: 'Отменить заказ', icon: cancel, color: '#E10D0D' },
    ],
  },
  //------------------Исполнитель установил объем------------------
  worker_set_volume: {
    step: 4,
    subtitle: 'Чтобы перейти в к завершению заказа, подтверди объем оказанных услуг',
    actions: [
      {
        text: 'Подтвердить объем',
        action: 'confirm_volume',
        icon: done,
      },
    ],
    info: React.createElement(
      'p',
      { style: { color: '#000' } },
      'Нажимая «Подтвердить» ты фиксируешь объем оказанных услуг и исполнитель может перейти к завершению заказа',
    ),
    showPrimaryButton: true,
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
      { id: 'cancel', name: 'Отменить заказ', icon: cancel, color: '#E10D0D' },
    ],
  },
  //------------------Заказчик установил объем------------------
  customer_set_volume: {
    step: 4,
    subtitle: 'Заказ в работе. Ожидаем завершения заказа исполнителем.',
    actions: [
      {
        text: 'Подтвердить объем',
        action: 'confirm_volume',
        icon: done,
      },
    ],
    info: false,
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'edit', name: 'Редактировать объем', icon: edit },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
      { id: 'cancel', name: 'Отменить заказ', icon: cancel, color: '#E10D0D' },
    ],
  },
  worker_finished_order: {
    step: 5,
    subtitle: 'Прими работу и подтверди выполнение заказа',
    actions: [
      {
        text: 'Завершить заказ',
        action: 'finish_order',
        icon: done,
      },
    ],
    info: React.createElement(
      'p',
      { style: { color: '#000' } },
      'Нажимая "Завершить заказ", ты подписываешь Акт оказанных услуг',
    ),
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
      { id: 'cancel', name: 'Отменить заказ', icon: cancel, color: '#E10D0D' },
    ],
  },
  work_success: {
    step: 5,
    subtitle: 'Исполнитель завершил заказ',
    actions: null,
    info: false,
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
      { id: 'cancel', name: 'Отменить заказ', icon: cancel, color: '#E10D0D' },
    ],
  },
  act_signed_by_worker: {
    step: 5,
    subtitle: 'Исполнитель подписал акт',
    actions: [
      {
        text: 'Завершить заказ',
        action: 'finish_order',
        icon: done,
      },
    ],
    info: React.createElement(
      'p',
      { style: { color: '#000' } },
      'Нажимая "Завершить заказ", ты подписываешь Акт оказанных услуг',
    ),
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
      { id: 'cancel', name: 'Отменить заказ', icon: cancel, color: '#E10D0D' },
    ],
  },
  payment_in_progress: {
    step: 6,
    subtitle: 'Заказ завершен. Готовим выплату (до 3х часов)',
    actions: null,
    info: false,
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
    ],
  },
  worker_tried_another_withdraw: {
    step: 6,
    subtitle: 'Исполнитель запросил выплату на другие реквизиты',
    actions: null,
    info: false,
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
    ],
  },
  act_signed_by_customer: {
    step: 6,
    subtitle: 'Заказчик подписал акт',
    actions: null,
    info: false,
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
    ],
  },
  payment_failed: {
    step: 7,
    subtitle:
      'Нам не удалось совершить выплату на реквизиты, указанные исполнителем. Мы запросили у исполнителя новые данные для оплаты',
    actions: null,
    info: false,
    isError: true,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
    ],
  },
  payment_returned: {
    step: 7,
    subtitle:
      'Банк получателя вернул платеж. Мы запросили у исполнителя новые данные для оплаты',
    actions: null,
    info: false,
    isError: true,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
    ],
  },
  payment_success: {
    step: 7,
    subtitle: 'Зачисление денежных средств обычно происходит от 5 минут до 24 часов',
    actions: null,
    info: false,
    isError: false,
    isGray: false,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
    ],
  },
  order_canceled: {
    step: null,
    subtitle: 'Сегодня в 12:35',
    actions: null,
    info: false,
    isError: false,
    isGray: true,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
    ],
  },
  order_draft: {
    step: null,
    subtitle: 'Опубликуй или измени задание',
    actions: [
      {
        text: 'Опубликовать',
        action: 'save',
        icon: done,
      },
    ],
    info: React.createElement(
      'p',
      { style: { color: '#000' } },
      'Нажимая "Опубликовать", ты подписываешь Договор с исполнителем',
    ),
    isError: false,
    isGray: true,
    listItems: [{ id: 'history', name: 'История', icon: history }],
  },
  order_published: {
    step: null,
    subtitle: 'Опубликуй или измени задание',
    actions: null,
    info: false,
    isError: false,
    isGray: true,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
    ],
  },
  worker_rejected_by_customer: {
    step: null,
    subtitle: 'Выбери исполнителя и опубликуй заказ',
    actions: null,
    info: false,
    isError: false,
    isGray: true,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
    ],
  },
  order_canceled_by_platform: {
    step: null,
    subtitle: 'Инфо',
    actions: null,
    info: false,
    isError: false,
    isGray: true,
    listItems: [
      { id: 'history', name: 'История', icon: history },
      { id: 'create_new', name: 'Создать заново', icon: repeat },
    ],
  },
};

type ReceiptError = {
  title: string;
  message: string;
  repeatable: boolean;
};

export const calculateStepInfo = (
  status?: keyof typeof STEPS_MAP,
  receipt?: { status: string; error?: ReceiptError },
  statusData?: { created_at?: string },
  is_unit_based?: boolean,
): StepInfo => {
  if (status === 'worker_approved_order' && is_unit_based) {
    status = 'worker_approved_order_unit_based';
  }
  if (status && STEPS_MAP[status]) {
    if (status === 'act_signed_by_customer' && receipt) {
      if (receipt.status === 'error') {
        return {
          ...STEPS_MAP[status],
          subtitle: receipt.error?.message || 'Произошла ошибка при формировании чека',
          info: null,
          isError: true,
        };
      }

      if (receipt.status === 'in_progress') {
        return {
          ...STEPS_MAP[status],
          subtitle: 'Формирование чека в процессе',
          info: null,
        };
      }
    }

    if (status === 'order_canceled' && statusData?.created_at) {
      return {
        ...STEPS_MAP[status],
        subtitle: formatDateWithTime(statusData.created_at),
      };
    }

    if (status === 'order_canceled_by_platform' && statusData?.created_at) {
      return {
        ...STEPS_MAP[status],
        subtitle: formatDateWithTime(statusData.created_at),
      };
    }

    if (status === 'moderation_failed' && statusData?.created_at) {
      return {
        ...STEPS_MAP[status],
        subtitle: formatDateWithTime(statusData.created_at),
      };
    }

    return STEPS_MAP[status];
  }

  return {
    step: 1,
    subtitle: 'Заполни поля для ввода и выбери исполнителя',
    actions: [
      {
        text: 'Опубликовать',
        action: 'save',
        icon: done,
      },
    ],
    info: React.createElement(
      'p',
      { style: { color: '#000' } },
      'Нажимая "Опубликовать", ты подписываешь Договор с исполнителем',
    ),
    isError: false,
    isGray: false,
    listItems: [{ id: 'draft', name: 'Сохранить черновик', icon: save }],
  };
};
